(function (root, factory) {
  var api = factory();
  if (typeof module === 'object' && module.exports) {
    module.exports = api;
  }
  if (root) {
    root.RunItConsentCore = api;
  }
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';

  function createConsentSync(options) {
    var loadAnalytics = options && options.loadAnalytics;
    var optOut = options && options.optOut;
    if (typeof loadAnalytics !== 'function' || typeof optOut !== 'function') {
      throw new TypeError('Consent sync requires loadAnalytics and optOut functions');
    }
    var loaded = false;
    return function sync(consent, processingAllowed) {
      var permitted = !!(consent && consent.analytics === 'yes' && processingAllowed === true);
      if (permitted) {
        if (!loaded) {
          loadAnalytics();
          loaded = true;
        }
        return 'enabled';
      }
      if (loaded) optOut({ clear_persistence: true });
      return 'disabled';
    };
  }

  /* Cookie / storage names that only exist for one optional purpose: Meta's _fbp/_fbc
     and UpPromote's own prefixes (marketing), PostHog's ph_/__ph_ (analytics). Wiped
     while the visitor's answer for that purpose is "no", so a refusal also removes what
     was set before it. Essentials (cart, localization, _shopify_*, _tracking_consent,
     wishlist, blackjack) never match. */
  var REFUSABLE = {
    marketing: /^(_fbp|_fbc|_up_|__up_|scaaf_|up_uppromote_)/,
    analytics: /^(ph_|__ph_)/
  };

  function isRefusedKey(name, consent) {
    var key = String(name || '');
    return Object.keys(REFUSABLE).some(function (purpose) {
      return !!consent && consent[purpose] === 'no' && REFUSABLE[purpose].test(key);
    });
  }

  return {
    createConsentSync: createConsentSync,
    isRefusedKey: isRefusedKey
  };
});
